import PaymentsDueTable from './PaymentsDueTable';

export default PaymentsDueTable;
